export default __webpack_public_path__ + "static/media/students-active.aa444855.svg";